import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    // Show the first panel by default
    this.showPanel(0);
  }

  switch(event) {
    event.preventDefault();

    const clickedTab = event.currentTarget;
    const targetId = clickedTab.getAttribute('href').substring(1); // Remove the #

    // Remove active class from all tabs
    this.tabTargets.forEach(tab => tab.classList.remove('tab-active'));

    // Add active class to clicked tab
    clickedTab.classList.add('tab-active')

    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add('hidden')
    })

    // Show the target panel
    const targetPanel = this.panelTargets.find(panel => panel.id === targetId)
    if (targetPanel) {
      targetPanel.classList.remove('hidden')
    } else {
      console.error("Panel not found:", targetId)
    }
  }

  showPanel(index) {
    // Hide all panels first
    this.panelTargets.forEach(panel => panel.classList.add('hidden'))

    // Show the specified panel
    if (this.panelTargets[index]) {
      this.panelTargets[index].classList.remove('hidden')
    }

    // Update tab active states
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('tab-active')
      } else {
        tab.classList.remove('tab-active')
      }
    })
  }
}
